import { render, staticRenderFns } from "./Print.vue?vue&type=template&id=2fa54de8&scoped=true"
import script from "./Print.vue?vue&type=script&lang=js"
export * from "./Print.vue?vue&type=script&lang=js"
import style0 from "./Print.vue?vue&type=style&index=0&id=2fa54de8&prod&lang=scss&scoped=true"
import style1 from "./Print.vue?vue&type=style&index=1&id=2fa54de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa54de8",
  null
  
)

export default component.exports